var $00c305263d1eecfa$exports = {};
$00c305263d1eecfa$exports = {
    "help": `Ohje`,
    "info": `Tiedot`
};


export {$00c305263d1eecfa$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
